var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"cursor-pointer",attrs:{"title":_vm.$t('auto_size')},on:{"click":_vm.autoSizeAll}},[_c('i',{staticClass:"fas fa-arrows-alt-h",staticStyle:{"font-size":"15px","margin-left":"5px"}})])}
var staticRenderFns = []

export { render, staticRenderFns }